export const COLUMN_SIZE = 256;
export const COLUMN_SIZE_THIN = 160;
export const COLUMN_GAP = 24;
